import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'

export function ExtractNewInfo(indata, newpInfo) {
    if (newpInfo === undefined) {
        newpInfo = {}
    }
    for (let index = 0; index < indata.datas.length; index++) {
        const code = CLAPI.getData(indata, 'code', index)
        const newprc = CLAPI.getData(indata, 'newprc', index)
        const newmny = CLAPI.getData(indata, 'newmny', index)
        const newmmp = CLAPI.getData(indata, 'newmmp', index)
        const curDate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
        if (newpInfo[code] === undefined) {
            newpInfo[code] = { date : curDate, nowprc : newprc, newprc, newmny, newmmp }
        }
        if (curDate >= newpInfo[code].date) {
            newpInfo[code].date = curDate
            newpInfo[code].nowprc = newprc
        }
        newpInfo[code].newprc = newprc
        newpInfo[code].newmny = newmny
        newpInfo[code].newmmp = newmmp
    }
    return newpInfo
}

const ainfo_field = 'msec,code,name,style,stopup,stopdn,agomny,offday,agommp,fright,wstake,fstake,income,assets,moneys,shares'

const market_head = 'index,agop,newp,crate,nowp,wrate,newmny,newmmp,' + ainfo_field

export function AinfoToMarket(indata, codeInfo, newpInfo) {
    let market = []
    let markets = []
    const arrayfields = DATAS.strsToArray(ainfo_field);
    // DATAS.strsToArray(factor_fields);
    for (let index = 0; index < indata.datas.length; index++) {
        const code = CLAPI.getData(indata, 'code', index)
        const agoprc = CLAPI.getData(indata, 'agoprc', index)
        const nowprc = newpInfo[code] === undefined ? 0.0 : newpInfo[code].nowprc
        const newprc = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newprc
        const newmny = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newmny
        const newmmp = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newmmp
        const crate = (newprc - agoprc) / agoprc
        const wrate = (nowprc - agoprc) / agoprc
        const style = CLAPI.getData(indata, 'style', index)
        if (style === 0) {
            continue
        }
        market = [
            markets.length + 1,
            agoprc,
            newprc,
            crate,
            nowprc,
            wrate,
            newmny,
            newmmp,
        ]
        for (let fdi = 0; fdi < arrayfields.length; fdi++) {
            market.push(CLAPI.getData(indata, arrayfields[fdi], index))
        }
        markets.push(market)
    }
    return { 
        fields : DATAS.fieldsToFieldsIndex(market_head),
        datas  : markets}    
}

const zxcode_head = 'index,selday,selprc,agop,newp,crate,nowp,wrate,newmny,newmmp,' + ainfo_field

// export function AinfoToCharList(indata, codeInfo, newpInfo, selected) {
//     let market = []
//     let markets = []
//     const arrayfields = DATAS.strsToArray(ainfo_field);
//     // DATAS.strsToArray(factor_fields);
//     for (let index = 0; index < indata.datas.length; index++) {
//         const code = CLAPI.getData(indata, 'code', index)
//         let findindex = -1
//         for (let sindex = 0; sindex < selected.datas.length; sindex++) {
//             if (code === CLAPI.getData(selected, 'code', sindex)) {
//                 findindex = sindex;
//                 break;
//             }         
//         }
//         if (findindex < 0) {
//             continue
//         }
//         const agoprc = CLAPI.getData(indata, 'agoprc', index)
//         const nowprc = newpInfo[code] === undefined ? 0.0 : newpInfo[code].nowprc
//         const newprc = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newprc
//         const newmny = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newmny
//         const newmmp = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newmmp

//         const selday = CLAPI.getData(selected, 'date', findindex) || CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
//         const selprc = CLAPI.getData(selected, 'newp', findindex) || newprc

//         const crate = (newprc - agoprc) / agoprc
//         const wrate = (nowprc - selprc) / selprc
        
//         market = [
//             markets.length + 1,
//             selday,
//             selprc,
//             agoprc,
//             newprc,
//             crate,
//             nowprc,
//             wrate,
//             newmny,
//             newmmp,
//         ]
//         for (let fdi = 0; fdi < arrayfields.length; fdi++) {
//             market.push(CLAPI.getData(indata, arrayfields[fdi], index))
//         }
//         markets.push(market)
//     }
//     // console.log(FIELD_FTREND, markets);
//     return { 
//         fields : DATAS.fieldsToFieldsIndex(zxcode_head),
//         datas  : markets}    
// }

export function AinfoToCharList(indata, codeInfo, newpInfo, selected) {
    let market = []
    let markets = []
    const arrayfields = DATAS.strsToArray(ainfo_field);
    
    for (let sindex = 0; sindex < selected.datas.length; sindex++) {
        const code = CLAPI.getData(selected, 'code', sindex)
        if (newpInfo[code] === undefined) {
            continue
        }
        
        const infoidx = codeInfo[code].index
        const agoprc = CLAPI.getData(indata, 'agoprc', infoidx)
        const nowprc = newpInfo[code].nowprc
        const newprc = newpInfo[code].newprc
        const newmny = newpInfo[code].newmny
        const newmmp = newpInfo[code].newmmp

        const selday = CLAPI.getData(selected, 'date', sindex) || newpInfo[code].date
        const selprc = CLAPI.getData(selected, 'newp', sindex) || newprc

        const crate = (newprc - agoprc) / agoprc
        const wrate = (nowprc - selprc) / selprc
        
        
        market = [
            markets.length + 1,
            selday,
            selprc,
            agoprc,
            newprc,
            crate,
            nowprc,
            wrate,
            newmny,
            newmmp,
        ]
        
        for (let fdi = 0; fdi < arrayfields.length; fdi++) {
            market.push(CLAPI.getData(indata, arrayfields[fdi], infoidx))
        }
        markets.push(market)
    }
    // console.log(FIELD_FTREND, markets);
    return { 
        fields : DATAS.fieldsToFieldsIndex(zxcode_head),
        datas  : markets}    
}

const adjust_head = 'index,curvol,curavgp,curmaxp,agop,newp,crate,nowp,wrate,newmny,newmmp,' + ainfo_field

export function AinfoToAdjust(indata, codeInfo, newpInfo, selected) {
    let market = []
    let markets = []
    const arrayfields = DATAS.strsToArray(ainfo_field);
    // DATAS.strsToArray(factor_fields);
    for (let index = 0; index < indata.datas.length; index++) {
        const code = CLAPI.getData(indata, 'code', index)
        let findindex = -1
        for (let sindex = 0; sindex < selected.datas.length; sindex++) {
            if (code === CLAPI.getData(selected, 'code', sindex)) {
                findindex = sindex;
                break;
            }         
        }
        if (findindex < 0) {
            continue
        }
        const agoprc = CLAPI.getData(indata, 'agoprc', index)
        const nowprc = newpInfo[code] === undefined ? 0.0 : newpInfo[code].nowprc
        const newprc = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newprc
        const newmny = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newmny
        const newmmp = newpInfo[code] === undefined ? 0.0 : newpInfo[code].newmmp

        const curprc = CLAPI.getData(selected, 'curavgp', findindex) || newprc

        const crate = (newprc - agoprc) / agoprc
        const wrate = (nowprc - curprc) / curprc
        
        market = [
            markets.length + 1,
            CLAPI.getData(selected, 'curvol', findindex),
            curprc,
            CLAPI.getData(selected, 'curmaxp', findindex),
            agoprc,
            newprc,
            crate,
            nowprc,
            wrate,
            newmny,
            newmmp,
        ]
        for (let fdi = 0; fdi < arrayfields.length; fdi++) {
            market.push(CLAPI.getData(indata, arrayfields[fdi], index))
        }
        markets.push(market)
    }
    // console.log(FIELD_FTREND, markets);
    return { 
        fields : DATAS.fieldsToFieldsIndex(adjust_head),
        datas  : markets
    }    
}
//////////////////////
// trend define
//////////////////////

const trend_field = 'status,curr_days,curr_bigm,fast_emzf,fast_emzr,fast_bidr,fast_summ,near_upsf,near_dnsf,mood_upbf,mood_upbr,mood_dnbf,mood_dnbr,mood_sumf,mood_sumr,emny_summ,emny_05_r,emny_10_r,emny_20_r,wave_bsmb,wave_bigm,ep_seejgf,ep_seeshf,ep_seerzf,ep_backzf,fast_sumf,updn_zf_r,updn_sm_r,area_snpr,fast_bigm'

const FIELD_FTREND = DATAS.fieldsMergeFieldsIndex('index,nums,code,name,msec,newp,rate', trend_field)

export const ask_trend_field = 'kname,msecstamp,midp,stoped,' + trend_field

export function AinfoToTrend1(indata, codeInfo, newpInfo, trend) {
    const ARRAY_FTREND = DATAS.strsToArray(trend_field);
    let market = []
    let codes = {}
    for (let index = 0; index < indata.datas.length; index++) {
        if (CLAPI.getData(indata, 'stoped', index) === 0 || CLAPI.getData(indata, 'curr_days', index) <= 60) {
            continue
        }
        if (CLAPI.getData(indata, 'fast_emzr', index) <= 0 || CLAPI.getData(indata, 'fast_bidr', index) <= 0.25 ||
            CLAPI.getData(indata, 'wave_bsmb', index) <= 1 || CLAPI.getData(indata, 'wave_bigm', index) <= 0) {
            continue
        }
        if (!((CLAPI.getData(indata, 'emny_summ', index) > 0 && CLAPI.getData(indata, 'emny_05_r', index) > CLAPI.getData(indata, 'emny_10_r', index)) ||
            (CLAPI.getData(indata, 'emny_05_r', index) > CLAPI.getData(indata, 'emny_10_r', index) && CLAPI.getData(indata, 'emny_10_r', index) > CLAPI.getData(indata, 'emny_20_r', index)))) {
            continue
        }
        if (!(CLAPI.getData(indata, 'mood_sumf', index) > 0.1 || (CLAPI.getData(indata, 'mood_upbr', index) > 0 && CLAPI.getData(indata, 'mood_dnbr', index) > 0) )) {
            continue
        }
        const ups = CLAPI.getData(indata, 'near_upsf', index)
        const dns = CLAPI.getData(indata, 'near_dnsf', index)
        if (!((dns === 0 && ups > 25) || (dns > 0 && ups > 50 && ups / dns > 1.25) || (dns > 0 && ups > 100 && ups / dns > 1))) {
            continue
        }

        const status = CLAPI.getData(indata, 'status', index)
        if (!((status !== 3 && status!== 5 && CLAPI.getData(indata, 'fast_summ', index) > 20000) || (status === 3 && CLAPI.getData(indata, 'fast_summ', index) > 1000))) {
            continue
        }
        
        if (!(CLAPI.getData(indata, 'ep_seejgf', index) > 0 || CLAPI.getData(indata, 'ep_seerzf', index) > 0)) {
            continue
        }
        const code = CLAPI.getData(indata, 'kname', index)
        const midp = CLAPI.getData(indata, 'midp', index)
        const rate = newpInfo[code] === undefined ? 0.0 : (newpInfo[code].newp - midp) / midp
        // if (code === 'SZ300688') {
        //     console.log(newpInfo[code], midp, rate);
        // }
        market = [
            code,
            codeInfo[code].static.name,
            CLAPI.Utils.strMsecToMTime(CLAPI.getData(indata, 'msecstamp', index)),
            midp,
            rate,
        ]
        for (let fdi = 0; fdi < ARRAY_FTREND.length; fdi++) {
            // console.log(ARRAY_FTREND[fdi]);
            market.push(CLAPI.getData(indata, ARRAY_FTREND[fdi], index))
        }
        if (codes[code] === undefined) {
            codes[code] = { market, nums : 1}
        }
        else {
            codes[code].market = market
            codes[code].nums ++
        }
    }
    // console.log(codes);
    let markets = []
    for (let codeinfo in codes) {
        codes[codeinfo].market.unshift(codes[codeinfo].nums)
        codes[codeinfo].market.unshift(markets.length + 1)
        markets.push(codes[codeinfo].market)
    }
    // console.log(FIELD_FTREND, markets);
    return { fields : FIELD_FTREND, datas: markets}    
}

export function AinfoToTrend2(indata, codeInfo, newpInfo, trend) {
    const ARRAY_FTREND = DATAS.strsToArray(trend_field);
    let market = []
    let codes = {}
    for (let index = 0; index < indata.datas.length; index++) {
        const code = CLAPI.getData(indata, 'kname', index)
        
        if (CLAPI.getData(indata, 'stoped', index) === 0 || CLAPI.getData(indata, 'curr_days', index) <= 60) {
            continue
        }
        if (CLAPI.getData(indata, 'fast_emzr', index) <= 0 || CLAPI.getData(indata, 'fast_bidr', index) <= 0.25) {
            continue
        }
        if (CLAPI.getData(indata, 'fast_sumf', index) > 12.36 || CLAPI.getData(indata, 'fast_sumf', index) < -6.18) {
            continue
        }
        if (!(CLAPI.getData(indata, 'emny_summ', index) > 0)) {
            continue
        }
        if (!(CLAPI.getData(indata, 'mood_sumf', index) > 0.1 || (CLAPI.getData(indata, 'mood_upbr', index) > 0 && CLAPI.getData(indata, 'mood_dnbr', index) > 0) )) {
            continue
        }
        const ups = CLAPI.getData(indata, 'near_upsf', index)
        const dns = CLAPI.getData(indata, 'near_dnsf', index)
        // if (code === 'SZ301306') console.log('10', ups, dns);
        if (!((dns === 0 && ups > 25) || (dns > 0 && ups > 50 && ups / dns > 1.25))) {
            continue
        }
        // if (code === 'SZ301306') console.log('12');
        if (!(CLAPI.getData(indata, 'ep_backzf', index) > 0)) {
            continue
        }
        // if (code === 'SZ301306') console.log('21');
        if (!(CLAPI.getData(indata, 'fast_emzf', index) > 1.0)) {
            continue
        }
        
        const status = CLAPI.getData(indata, 'status', index)
        if (!((status !== 3 && status!== 5 && CLAPI.getData(indata, 'fast_summ', index) > 20000) || (status === 3 && CLAPI.getData(indata, 'fast_summ', index) > 1000))) {
            continue
        }
        // if (code === 'SZ301306') console.log('25');
        // const code = CLAPI.getData(indata, 'kname', index)
        const midp = CLAPI.getData(indata, 'midp', index)
        const rate = newpInfo[code] === undefined ? 0.0 : (newpInfo[code].newp - midp) / midp
        
        market = [
            code,
            codeInfo[code].static.name,
            CLAPI.Utils.strMsecToMTime(CLAPI.getData(indata, 'msecstamp', index)),
            CLAPI.getData(indata, 'midp', index),
            rate,
        ]
        for (let fdi = 0; fdi < ARRAY_FTREND.length; fdi++) {
            // console.log(ARRAY_FTREND[fdi]);
            market.push(CLAPI.getData(indata, ARRAY_FTREND[fdi], index))
        }
        if (codes[code] === undefined) {
            codes[code] = { market, nums : 1}
        }
        else {
            codes[code].market = market
            codes[code].nums ++
        }
    }
    let markets = []
    for (let codeinfo in codes) {
        // console.log(codes[codeinfo]);
        codes[codeinfo].market.unshift(codes[codeinfo].nums)
        codes[codeinfo].market.unshift(markets.length + 1)
        markets.push(codes[codeinfo].market)
    }
    console.log(FIELD_FTREND, markets);
    return { fields : FIELD_FTREND, datas: markets}    
}